<script lang="ts">
  import type { CommentAttachment } from "../../comments/CommentTypes.js";
  import css from "../../../../css/comments.pcss.json";
  import cn from "classnames";

  export let attachment: CommentAttachment
  export let onlyAttachment: boolean = false

  let noImage = false

  if (attachment.url.startsWith('//')) {
    attachment.url = 'https:' + attachment.url
  }

  const domain = new URL(attachment.url).host
  const attachmentUrl = encodeURIComponent(attachment.url)

  $: isLargePreview = attachment?.isLargePreview ?? false

  const hideImage = () => {
    noImage = true
  }
</script>

<a
  class={cn({
    [css['comment__attachment__link']]: true,
    [css['comment__attachment__link--large-preview']]: isLargePreview,
    [css['comment__attachment--only']]: onlyAttachment
  })}
  href={`/to?${attachmentUrl}`}
  target="_blank"
  rel="nofollow ugc"
>
  <div class={css['comment__attachment__link__container']}>
    {#if isLargePreview && !noImage}
      <img
        alt=""
        class={css['comment__attachment__link__big-preview']}
        src={attachment.preview_url}
        on:error={hideImage}
        loading="lazy"
      />
    {/if}
    <span class={css['comment__attachment__link__domain']}>{domain}</span>
    <span class={css['comment__attachment__link__title']}>{attachment.title || attachment.url}</span>
    <slot name="delete"></slot>
  </div>
</a>
